import { useTranslation } from "react-i18next";

export const useActivityTranslation = () => {
  const { t } = useTranslation();

  const getActionTranslation = (action: string) => {
    // Try to get the translation from activityActions
    const translationKey = `activityActions.${action}`;
    const translation = t(translationKey);

    // If no translation found (returns the key), format the string manually
    if (translation === translationKey) {
      return formatActionString(action);
    }

    return translation;
  };

  // Fallback formatter for actions without direct translations
  const formatActionString = (action: string) => {
    return action
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  return {
    getActionTranslation,
  };
};
